import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { RewriteFrames as RewriteFramesIntegration } from '@sentry/integrations';

Sentry.init({
	dsn: process.env.SENTRY_DSN,
	environment: process.env.NODE_ENV,
	release: process.env.SENTRY_RELEASE_TAG, // TODO: Release tag should come from GitHub.
	integrations: [
		new BrowserTracing(),
		new RewriteFramesIntegration({
			iteratee: frame => {
				let sourcemapUrl = null;
				if (frame.filename) {
					sourcemapUrl = frame.filename.replace(/(\.js)(\?v)/g, `$1.map$2`);
				}

				const newFrame = {
					...frame,
					data: {
						sourcemap: sourcemapUrl,
					},
				};

				return newFrame;
			},
		})
	],
	allowUrls: [
		/https?:\/\/cdn\.shopify\.com/,
		/https?:\/\/((www)\.)?paireyewear\.com/,
		/https?:\/\/((www)\.)?pair-eyewear\.myshopify\.com/,
		/https?:\/\/((www)\.)?paireyewear-staging\.myshopify\.com/
	],
});
